import $ from 'jquery';
import Vue from 'vue';
import 'foundation-sites';
import 'foundation-sites/js/foundation.core';
import 'foundation-sites/js/foundation.util.mediaQuery';
import 'foundation-sites/js/foundation.dropdown';
import 'foundation-sites/js/foundation.dropdownMenu';
import 'foundation-sites/js/foundation.reveal';
// #
import 'waypoints/lib/noframework.waypoints';
import 'waypoints/lib/shortcuts/sticky';
//
import Cookies from 'js-cookie';
//
import ArticleSort from "./components/ArticleSort";
import Articles from "./components/Articles";
// #
import { config } from './app-config.js';
import './bootstrap.js';
import { makeSorterSelects } from './makeSorterSelects.js';
import './vendor/jquery.inview.js';
//
import "ie-array-find-polyfill";


window.$ = $;

//Save & update form fields to localstorage
// import FormStorage from 'form-storage';
// const formStorage = new FormStorage('[data-saveable]', {
//   name: 'user_form_data', // you can decide local-storage name
//   ignores: [
//     '[type="hidden"]',
//     '[type="password"]',
//   ]
// });
//Update values on page load
if ($("[data-saveable]").length) {
  formStorage.apply();
};
//Save values on form submit
$("[data-saveable]").on("submit", function () {
  formStorage.save();
});

//Basic $ stuff

let jQuery = $;
$(document).foundation();

if ($("#app").length) {

  new Vue({
    el: "#app",
    components: { ArticleSort, Articles }
  });

  window.Vue = Vue;

}

$.ajaxSetup({
  beforeSend: function (xhr) {
    xhr.setRequestHeader('X-WP-Nonce', $('[name="csrf_nonce"]').attr("content"));
  }
});

// $.post(config.vasApi + "/submissions/" + 123123, { firstname: "Timo", lastname: "Mäkinen" }).then(function(response) {
//   log(response);
//   return "ok";
// });

//Header click events
$(".dropdown-trigger button").on("click", (event) => {
  event.preventDefault();
  $("body").toggleClass("show-language-selector");
});

$(".search-icon button").on("click", (event) => {
  $("body").toggleClass("show-search-form");
});

$(".mobile-menu-button").on("click", (event) => {
  $("body").toggleClass("show-mobile-navigation");
})

//Article content zoom
$('.zoom-wrapper').on('inview', function (event, isInView) {
  if (isInView) {
    // element is now visible in the viewport
    $(this).addClass("is-visible");
  } else {
    // element has gone out of viewport
    $(this).removeClass("is-visible");
  }
});


$(document).on('nfFormReady', function () {
  console.log('Form is ready');
});

window.what = function () {
  jQuery('#nf-field-' + 7).val("inkaehdokas@mediapool.fi").trigger('change');
}

// Create a new object for custom validation of a custom field.
if (window.Marionette) {
  var ninjaMethods = Marionette.Object.extend({

    initialize: function () {
      if ($(".nf-form-content [name='email']").length) {
        Cookies.set("referer-page", document.location.toString());
      }
      // We have a form now
    }

  });
  // Ninja forms loader
  $(document).ready(function ($) {
    // Instantiate our custom controller, defined above.
    setTimeout(function () {
      new ninjaMethods();
    }, 1500);

  });
}

//PREFILL FORMS VALUE SAVES
let moveTourl = $(".save-prefill-values").prop("action");
moveTourl += "#scrollto";
$(".save-prefill-values").prop("action", moveTourl);
$(".save-prefill-values").on("submit", function () {
  $(".save-prefill-values").find("input").each(function () {
    Cookies.set("prefill-" + this.name, this.value)
  });
  Cookies.set("hide-above-the-fold", 1);
  return true;
});

//Auto scroll to prefill form
if (window.location.hash.toString() == "#scrollto") {
  let topTarget = $(".nf-loading-spinner").first().offset().top - 300;
  $("html, body").animate({ scrollTop: topTarget }, 1000);
  window.location.hash = "";
}

$(".form [data-close]").on("click", function () {

  let parentForm = $(this).parents(".form");

  Cookies.set(parentForm.attr("id"), '1', { expires: 7 });

  parentForm.remove();

  if ($("html").hasClass("has-splash")) {
    window.scrollTo(0, 0);
  }

  $("body, html").removeClass("has-splash");

});

//Sticky / Waypoints
var rightColumn = $(".form--sidebar");
if (rightColumn.length) {
  var waypoint = new Waypoint({
    element: rightColumn[0],
    handler: function (direction) {
      log("HANDLER", direction);
      if (direction == "down") {
        rightColumn.addClass('sticky-info');
      } else {
        rightColumn.removeClass('sticky-info');
      }
    }
  });
}

//
$(".module--donate form").on("submit", function (e) {
  e.preventDefault();

  var fields = $(this).serialize();
  var loc = document.location.toString().split("?")[0];
  loc = loc.toString().split("#")[0];
  var self = this;

  $.post("/wp-json/mp/donations", { data: fields, referer: loc }, function (response) {

    if (!response.error && response.href) {
      var win = window.location.href = response.href;
      if (win) {
        win.focus();
      } else {
        alert('Please allow popups for this website');
      }

    } else {
      var errorP = $("<p />").text(response.message).addClass("error-message").css({ marginTop: "20px" });
      $(self).remove(".error-message");
      $(self).find("button").after(errorP);
      log(errorP);
    }
  });
  console.log("END");

  return false;
})


//Stupid hybrid breadcrumbs hack
var seen = {};
$('.breadcrumbs__crumb').each(function () {
  var txt = $(this).find("span").text();
  log("txt", txt);
  if (seen[txt]) {
    $(this).remove();
  } else {
    seen[txt] = true;
  }
});

makeSorterSelects();


// FORM CONVERSION TRACKING
jQuery(document).ready(function () {

  $(".donation-form").on("submit", function () {
    //Sum
    var preselectedSum = $(".donation-form").find("[name=sum]:checked").val();
    var freeSum = $(".donation-form").find("[name=sum_free]").val();
    if (freeSum != "") {
      preselectedSum = freeSum;
    }
    if (!preselectedSum) {
      preselectedSum = 0;
    }
    ga('send', 'event', 'donation', 'submit', "Donation " + preselectedSum + " € : " + document.location.toString(), preselectedSum);
  });

  if (typeof Marionette !== 'undefined') {

    var nfConversionTracker = Marionette.Object.extend({

      initialize: function () {
        this.listenTo(Backbone.Radio.channel('forms'), 'submit:response', this.submitResponse);
      },

      submitResponse: function (response) {

        if ('error' == response) return;

        this.triggerEvent(response.data.settings.title);
      },

      triggerEvent: function (formTitle) {
        formTitle = formTitle + " : " + document.location.toString();
        try {
          ga('send', 'event', 'form', 'submit', formTitle);
        } catch (err) {
          console.log(err);
        }
      }

    });

    new nfConversionTracker();

  }
  //if



  if (Cookies.get("hide-above-the-fold") == 1) {
    $(".form--fold").remove();
    Cookies.remove("hide-above-the-fold");
  }



  //accordionlinks:
  if ($('.content-accordion').length > 0) {
    let hash = window.location.hash;
    if (hash != null) {
      accordionHash(hash)
    }

    window.addEventListener('popstate', function (event) {
      var hashTemp = window.location.hash;
      setTimeout(function () {
        accordionHash(hashTemp);
      }, 100);

    });

  }
  //length

  function accordionHash(hash) {
    if (hash == null) {
      hash = window.location.hash;
    }

    var elemTarget = $('div' + hash + ':first');
    if (elemTarget.length < 1) { return; }
    if (elemTarget.hasClass('show')) {
      //only scroll, when already open, eg. back button
      var y = elemTarget.offset();
      $(window).scrollTop(y.top - 120);
      return;
    }

    elemTarget.addClass('show').show();
    var y = elemTarget.offset();
    $(window).scrollTop(y.top - 120);
    setTimeout(function () {
      $(window).scrollTop(y.top - 120);
    }, 800);
  }

});



//cookie banner:


//if(document.getElementById('sb_instagram') || document.getElementById('twitterfeed') || document.getElementById('facebookiframe'))
/*vasemmisto pages always run */
if (1) {
  new CookiesEuBanner(function () {
    // Your code to launch when user accept cookies

    /*google analytics */



    gtag('js', new Date());
    gtag('config', 'UA-105857662-1');

    gtag('consent', 'update', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted'
    });
    gtag('set', 'ads_data_redaction', false);

    /*adform*/

    window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);
    window._adftrack.push({
      pm: 1586687
    });
    (function () { var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://track.adform.net/serving/scripts/trackpoint/async/'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); })();




    /* instagram : */
    if (document.getElementById('instafeed-XXXX')) {
      (function () {
        var instagram_url = document.getElementById('instafeed').getAttribute('data-instagram-handle')
        if (instagram_url && instagram_url.length > 1) {
          new InstagramFeed({
            'username': instagram_url,
            'container': document.getElementById("instafeed"),
            'display_profile': true,
            'display_biography': false,
            'display_gallery': true,
            'callback': null,
            'styling': true,
            'items': 6,
            'items_per_row': 2,
            'margin': 1
          });
        }
      })();
    }


    /* twitter : */

    /* <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script> */

    if (document.getElementById('twitterfeed')) {
      var script = document.createElement("script");
      //script.type = "text/javascript";
      script.src = "https://platform.twitter.com/widgets.js";
      document.getElementById("twitterfeed").appendChild(script);
    }


    /* facebook iframe : */
    /* https://www.facebook.com/plugins/page.php?href={{fb_url}}%2F&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId */

    if (document.getElementById('facebookiframe')) {
      let fbElement = document.getElementById('facebookiframe');
      let facebookUrl = fbElement.getAttribute('data-src');
      fbElement.src = facebookUrl;

      let preloadElem = document.getElementById('some-preload-facebook');
      if (preloadElem != null) {
        preloadElem.parentNode.removeChild(preloadElem);
      }

    }

  }, true);
}


